import React from "react";

const RegularHours = () => {
  return <div>RegularHours</div>;
};

export default RegularHours;
